import React, { useState, useEffect } from 'react';
import { isValidUUID } from '../../utilities/offline_hooks_setup_apollo/offlineUtils';
import styles from './audio-wrapper.module.scss';
import { getOfflineFileUrl } from '../../hooks/offline-hooks/localForageDb';

const AudioWrapper = ({ audio, children }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const fetchAudio = async () => {
      if (isValidUUID(audio)) {
        const fetchedUrl = await getOfflineFileUrl(audio);
        setUrl(fetchedUrl);
      } else if (audio) {
        setUrl(audio);
      }
    };

    fetchAudio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audio]);

  // Return a fallback if the URL is not available yet
  if (!url) {
    return <div>Loading audio...</div>;
  }

  // Return the <source> element for the audio
  return (
    <audio controls className={styles.audio} src={url}>
      {children}
    </audio>
  );
};

export default AudioWrapper;
